import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import API from '../api'

import FaStarOutline from 'react-icons/fa/star-o'
import FaStar from 'react-icons/fa/star'

@autobind
class WorkExemplarMarker extends Component {
  constructor (props) {
    super(props)
  }

  markAsExemplar () {
    (!this.props.isExemplar
      ? API.put(`/v3/works/${this.props.workId}/mark_exemplar`)
      : API.put(`/v3/works/${this.props.workId}/unmark_exemplar`))
      .then(() => this.props.onExemplarMarked(!this.props.isExemplar))
  }

  render () {
    return (
      <div className='workMedia__marker'>
        <button className='btn btn-overlay' onClick={this.markAsExemplar}>{!this.props.isExemplar ? <FaStarOutline /> : <FaStar /> } WAGOLL</button>
      </div>
    )
  }
}

export default WorkExemplarMarker

WorkExemplarMarker.propTypes = {
  workId: PropTypes.string,
  isExemplar: PropTypes.bool,
  onExemplarMarked: PropTypes.func
}



// WEBPACK FOOTER //
// ./components/work/WorkExemplarMarker.js